import { StorySlide } from "../../../../models/stories.models"
import { HtmlContainer } from "./HtmlContainer"
import type { BaseContentProps, BaseTextContentProps } from "./types"

interface TextContentProps extends BaseContentProps, BaseTextContentProps {
  currentSlide: StorySlide
}

export const TextContent = ({
  currentSlide,
  content,
  ...props
}: TextContentProps) => {
  if (!content.text) {
    return null
  }

  return (
    <HtmlContainer
      {...props}
      html={content.text}
      textColor={currentSlide.textColor}
      boxColor={currentSlide.boxColor}
    />
  )
}
